import { useMutation } from '@apollo/client';
import { useCallback } from 'react';
import { DTOOLS_REVOKE_AUTHENTICATION } from 'src/graphql/entities/integrations/dtools/dtools.operations';
import { useNotifications } from 'src/utils/hooks';

type DtoolsRevokeConnectionQuery = {
  dtoolsRevokeAuthentication: {
    partnerId: number;
  };
};

type DtoolsAuthenticateQueryVariables = {
  params: {
    partnerId: number;
  };
};

export const useRevokeDtoolsAuthentication = () => {
  const { showErrorAlert, showSuccessAlert } = useNotifications();
  const [revokeConnectionMutation] = useMutation<
    DtoolsRevokeConnectionQuery,
    DtoolsAuthenticateQueryVariables
  >(DTOOLS_REVOKE_AUTHENTICATION, {
    optimisticResponse: (vars) => {
      return {
        dtoolsRevokeAuthentication: {
          partnerId: vars.params.partnerId,
        },
      };
    },

    onError: (error) => {
      showErrorAlert(error.message);
    },
    onCompleted: () => {
      showSuccessAlert('Revoked access to D-Tools Cloud');
    },
  });

  const revokeConnection = useCallback(
    async (partnerId: number) => {
      await revokeConnectionMutation({
        variables: {
          params: {
            partnerId,
          },
        },
        update: (cache, result) => {
          if (!result.data?.dtoolsRevokeAuthentication.partnerId) {
            return;
          }
          cache.evict({
            id: cache.identify({
              __typename: 'DtoolsAuthDetails',
              id: partnerId,
            }),
          });
        },
      });
    },
    [revokeConnectionMutation],
  );

  return {
    revokeConnection,
  };
};
